class LiveSearch {
    constructor() {
        this.searchInput = document.getElementById('Search-In-Modal');
        this.resetButton = document.querySelector('.reset__button');
        this.closeButton = document.querySelector('.search-modal__close-button');
        this.productGrid = document.querySelector('#product-grid');
        this.queriesList = document.querySelector('.search-bar-suggestions');
        this.lastQuery = '';
        this.searchTimeout = null;
        this.isMobileView = window.innerWidth <= 990;
        this.initialQueriesList = null;
        this.initialSuggestions = [];
        this.currentMatchingSuggestion = null;
        this.yotpoReinitialization = false;
        this.isReinitializingYotpo = false;
        this.isScrolling = false;
        this.isProcessingClick = false;
        this.blurOnScroll = true; // Configurable option to blur input on scroll
        this.lastScrollTop = 0;
        this.scrollThrottleTimeout = null;
        this.scrollPositionBeforeBlur = 0;
        this.searchModal = document.querySelector('details-modal.header__search');
        this.isSearchModalOpen = false;
        this.handleKeyDown = this.handleKeyDown.bind(this);

        this.initialViewportHeight = window.innerHeight;
        this.keyboardThreshold = 80; // Minimum height change to consider keyboard opened

        this.init();
        this.loadInitialState();
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.setupEventListeners();
            this.checkStickyStateForMobile();
        });
        window.addEventListener('resize', this.handleResize.bind(this));

        if (deviceIsMobile.matches) {
            this.searchInput.addEventListener('focus', this.handleSearchFocus.bind(this));
            this.searchInput.addEventListener('blur', this.handleSearchBlur.bind(this));
            window.addEventListener('scroll', this.handleScroll.bind(this));

            // Add Visual Viewport event listener
            if (window.visualViewport) {
                window.visualViewport.addEventListener(
                    'resize',
                    this.handleVisualViewportResize.bind(this),
                );
                // Initial call to set the CSS variable
                this.updateVisualViewportHeightVariable(window.visualViewport.height);
            }
        }

        if (this.searchModal) {
            this.searchModal.addEventListener('toggle', this.handleSearchModalToggle.bind(this));
        }
    }

    loadInitialState() {
        this.fetchInitialState(true, true);
    }

    setupEventListeners() {
        this.searchInput.addEventListener('input', this.handleInput.bind(this));
        this.searchInput.addEventListener('keydown', this.handleKeyDown);
        this.resetButton.addEventListener('click', this.handleReset.bind(this));
        this.closeButton.addEventListener('click', this.handleClose.bind(this));
        this.setupPredictiveSearchItemListeners();
        this.productGrid.addEventListener(
            'liveSearch:searchComplete',
            this.handleSearchComplete.bind(this),
        );
    }

    handleSearchModalToggle(event) {
        this.isSearchModalOpen = event.target.open;

        if (this.isSearchModalOpen) {
            this.handleSearchModalOpen();
        }
    }

    handleSearchModalOpen() {
        
    }

    handleKeyDown(event) {
        if (event.key === 'Enter') {
            event.preventDefault();

            this.searchInput.blur();
            //console.log('Enter pressed with empty search input');


        }

       

        
    }

    handleResize() {
        this.isMobileView = window.innerWidth <= 990;
    }

    handleInput() {
        clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            const query = this.searchInput.value.trim();

            if (query.length > 0) {
                this.activateSearch();
            }

            if (query === this.lastQuery) {
                return;
            }

            this.lastQuery = query;

            if (query.length === 0) {
                this.smoothScrollToTopAndReset();
            } else if (query.length >= 2) {
                this.checkForMatchingSuggestion(query);
            }
        }, 300);
    }

    handleSearchFocus() {
        if (this.isMobileView) {
            document.body.classList.add('search-focused');

            if (window.visualViewport) {
                setTimeout(() => {
                    this.updateVisualViewportHeightVariable(window.visualViewport.height - 55);
                    document.body.classList.add('keyboard-focused');
                }, 800);
                
            }
        }
    }

    handleVisualViewportResize(event) {
        const currentViewportHeight = event.target.height;
        this.updateVisualViewportHeightVariable(currentViewportHeight);

        const heightDifference = this.initialViewportHeight - currentViewportHeight;

        if (heightDifference > this.keyboardThreshold) {
            // Keyboard is likely open
            document.body.classList.add('keyboard-open');
        } else {
            // Keyboard is likely closed
            document.body.classList.remove('keyboard-open');
        }

        // You can add more logic here if needed, such as adjusting layout or scroll position
    }

    updateVisualViewportHeightVariable(height) {
        document.documentElement.style.setProperty('--visual-viewport-height', `${height}px`);
    }

    handleScroll() {
        
    }

    handleSearchBlur() {
        if (this.isMobileView) {
            document.body.classList.remove('search-focused');
            document.body.classList.remove('keyboard-focused');

            setTimeout(() => {
                this.updateVisualViewportHeightVariable(window.visualViewport.height - 55);
            }, 800);

            // Immediate scroll to the position before blur
            if (this.blurOnScroll) {
              //  window.scrollTo(0, this.scrollPositionBeforeBlur);
            }
        }
    }

    handleReset() {
        this.searchInput.value = '';
        this.smoothScrollToTopAndReset();
        this.searchInput.focus();
    }

    handleClose() {
        this.smoothScrollToTopAndReset(() => {
            this.fetchInitialState(false, true);
        });
    }

    resetSearch() {
        this.resetButton.classList.remove('show-reset');
        this.searchInput.classList.remove('searching-active');
        this.fetchInitialState(true, true);
    }

    activateSearch() {
        this.resetButton.classList.add('show-reset');
        this.searchInput.classList.add('searching-active');
    }

    checkForMatchingSuggestion(query) {
        const normalizedQuery = this.normalizeString(query);

        this.currentMatchingSuggestion = null;

        const matchingSuggestion = this.initialSuggestions.find((suggestion) => {
            const normalizedSuggestion = this.normalizeString(suggestion.text);
            return normalizedSuggestion.startsWith(normalizedQuery);
        });

        if (matchingSuggestion) {
            this.currentMatchingSuggestion = matchingSuggestion;
            const collectionURL = matchingSuggestion.collectionHandle;
            this.fetchStaticSuggestionContent(query, collectionURL);
        } else {
            this.performSearch(query);
        }
    }

    normalizeString(str) {
        return str
            .toLowerCase()
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '')
            .replace(/\s+/g, ' ')
            .trim();
    }

    performSearch(query) {
        this.showLoadingState();

        Promise.all([this.fetchPredictiveResults(query), this.fetchAdditionalProducts(query)])
            .then(([predictiveResults, additionalResults]) => {
                this.smoothScrollToTop(() => {
                    this.updateProductGrid(predictiveResults.products, additionalResults);
                    this.dispatchSearchCompleteEvent();
                });
            })
            .catch((error) => {
                console.error('Search error:', error);
                this.showErrorMessage();
                this.dispatchSearchCompleteEvent();
            })
            .finally(() => {
                this.hideLoadingState();
            });
    }

    updateProductGrid(predictiveResults, additionalResults) {
        this.productGrid.innerHTML = '';
        this.appendProductsToGrid(predictiveResults, additionalResults);

        const noResultsItem = this.productGrid.querySelector('.no-results-item');

        if (noResultsItem) {
            this.showNoResultsMessage();
        } else {
            this.hideNoResultsMessage();

            if (this.isMobileView) {
                const totalProducts =
                    this.productGrid.querySelectorAll('.plp-product-standard').length;
                this.updateMobileProductCount(totalProducts);
            }
        }
    }

    async fetchPredictiveResults(searchTerm) {
        try {
            const response = await fetch(
                `/search/suggest?q=${encodeURIComponent(
                    searchTerm,
                )}&resources[type]=product,query&resources[limit_scope]=each&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,body,variants.title,variants.sku,tag,vendor&section_id=predictive-search`,
            );
            const htmlString = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const productGrid = doc.querySelector('#product-grid');
            const queriesList = doc.querySelector('.search-bar-suggestions');
            return {
                products: productGrid
                    ? Array.from(productGrid.querySelectorAll('.plp-product-standard'))
                    : [],
                queries: queriesList ? Array.from(queriesList.children) : [],
            };
        } catch (error) {
            console.error('Failed to fetch predictive products:', error);
            return { products: [], queries: [] };
        }
    }

    async fetchAdditionalProducts(searchTerm) {
        try {
            const response = await fetch(
                `/search?q=${encodeURIComponent(searchTerm)}&view=ajax`,
            );
            const htmlString = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(htmlString, 'text/html');
            const productGrid = doc.querySelector('#product-grid');
            return productGrid
                ? Array.from(productGrid.querySelectorAll('.plp-product-standard'))
                : [];
        } catch (error) {
            console.error('Failed to fetch additional products:', error);
            return [];
        }
    }

    appendProductsToGrid(predictiveResults, additionalResults) {
        const initialHandles = new Set(
            predictiveResults.map((product) =>
                product.querySelector('.card-wrapper').getAttribute('data-frame-handle'),
            ),
        );

        predictiveResults.forEach((product) => {
            this.productGrid.insertAdjacentHTML('beforeend', product.outerHTML);
        });

        additionalResults.forEach((product) => {
            const handle = product
                .querySelector('.card-wrapper')
                .getAttribute('data-frame-handle');
            if (!initialHandles.has(handle)) {
                this.productGrid.insertAdjacentHTML('beforeend', product.outerHTML);
            }
        });
    }

    updateMobileProductCount(count) {
        if (this.isMobileView) {
            this.queriesList.innerHTML = `<h3>Products (${count} results)</h3>`;
        }
    }

    showNoResultsMessage() {
        if (this.isMobileView && this.initialQueriesList) {
            this.queriesList.innerHTML = this.initialQueriesList;
            this.setupPredictiveSearchItemListeners();
            document.querySelector('.search-queries h3').textContent = 'No results found';
        }
    }

    hideNoResultsMessage() {}

    fetchInitialState(updateProducts, updateSuggestions) {
        fetch(`/?sections=predictive-search-initial`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch initial state');
                }
                return response.json();
            })
            .then((data) => {
                const initialStateHtml = data['predictive-search-initial'];
                const parser = new DOMParser();
                const doc = parser.parseFromString(initialStateHtml, 'text/html');
                const initialState = doc.querySelector('#product-grid');
                const initialQueriesList = doc.querySelector('.search-bar-suggestions');

                if (updateProducts && initialState) {
                    this.productGrid.innerHTML = initialState.innerHTML;
                }
                if (updateSuggestions && initialQueriesList) {
                    this.initialQueriesList = initialQueriesList.innerHTML;
                    if (this.isMobileView) {
                        this.queriesList.innerHTML = this.initialQueriesList;
                    }
                    this.initialSuggestions = Array.from(
                        initialQueriesList.querySelectorAll('.predictive-search__item'),
                    ).map((item) => ({
                        text: item.textContent.trim(),
                        collectionHandle: item.getAttribute('href'),
                    }));
                    this.setupPredictiveSearchItemListeners();
                }
            })
            .catch((error) => console.error('Failed to fetch initial state:', error));
    }

    setupPredictiveSearchItemListeners() {
        const items = document.querySelectorAll('.predictive-search__item');

        items.forEach((item) => {
            item.addEventListener('click', this.handlePredictiveSearchItemClick.bind(this));
        });
    }

    handlePredictiveSearchItemClick(event) {
        if (this.isProcessingClick) {
            event.preventDefault();
            return;
        }

        this.isProcessingClick = true;

        const item = event.currentTarget;
        const query = item.textContent.trim();
        const collectionURL = item.getAttribute('href');

        if (item.parentElement.classList.contains('static-suggestion')) {
            event.preventDefault();
            this.searchInput.classList.add('static-selection-selected');
            this.searchInput.value = query.trim();
            this.fetchStaticSuggestionContent(query, collectionURL);
            this.resetButton.classList.add('show-reset');
            this.searchInput.classList.add('searching-active');
        } else {
            this.triggerSearch(query);
        }

        setTimeout(() => {
            this.isProcessingClick = false;
        }, 500);
    }

    fetchStaticSuggestionContent(query, collectionURL) {
        this.showLoadingState();
        fetch(`${collectionURL}?view=collection-based-search`)
            .then((response) => response.text())
            .then((htmlString) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');
                this.smoothScrollToTop(() => {
                    if (this.productGrid) {
                        this.productGrid.innerHTML = doc.body.innerHTML;
                    }
                    if (this.isMobileView) {
                        const noResultsItem = this.productGrid.querySelector('.no-results-item');
                        if (!noResultsItem) {
                            const productCount =
                                this.productGrid.querySelectorAll(
                                    '.plp-product-standard',
                                ).length;
                            this.updateMobileProductCount(productCount);
                        } else {
                            this.showNoResultsMessage();
                        }
                    }
                    this.dispatchSearchCompleteEvent();
                });
            })
            .catch((error) => {
                console.error('Failed to fetch static suggestion content:', error);
                this.dispatchSearchCompleteEvent();
            })
            .finally(() => {
                this.hideLoadingState();
            });
    }

    triggerSearch(query) {
        this.searchInput.value = query;
        if (query.length > 0) {
            this.performSearch(query);
        }
    }

    smoothScrollToTopAndReset(callback) {
        this.smoothScrollToTop(() => {
            this.resetSearch();
            if (callback) callback();
        });
    }

    smoothScrollToTop(callback) {
        
        if (this.isScrolling) {
            if (callback) setTimeout(callback, 100);
            return;
        }

        this.isScrolling = true;
        const scrollableArea = this.isMobileView
            ? document.querySelector('.predictive-search')
            : document.querySelector('.predictive-search #product-grid');

        if (scrollableArea) {
            const scrollOptions = {
                top: 0,
                behavior: 'smooth',
            };

            scrollableArea.scrollTo(scrollOptions);

            const checkScrollEnd = () => {
                if (scrollableArea.scrollTop === 0) {
                    this.isScrolling = false;
                    if (callback) callback();
                } else {
                    requestAnimationFrame(checkScrollEnd);
                }
            };

            requestAnimationFrame(checkScrollEnd);
        } else {
            this.isScrolling = false;
            if (callback) callback();
        }
    }

    showLoadingState() {
        console.log('Loading...');
    }

    hideLoadingState() {
        console.log('Loading complete');
    }

    dispatchSearchCompleteEvent() {
        const event = new CustomEvent('liveSearch:searchComplete');
        this.productGrid.dispatchEvent(event);
    }

    handleSearchComplete() {
        
    }

    checkAndReinitializeYotpo() {
       
    }

    reinitializeYotpo() {
        
    }

    showErrorMessage() {
        console.error('An error occurred while searching. Please try again.');
    }

    checkStickyStateForMobile() {
        // Implement this method based on your specific requirements for mobile sticky state
    }
}

const liveSearch = new LiveSearch();
